class Article {
    constructor(_el, _articleLength){
        this.container = $(_el);
        this.container.css({ width: 100/_articleLength + '%'});
    }

    get anchor(){
        return this.container.data('anchor');
    }

    showIn(){
        this.container.toggleClass('active', true);
    }

    showOut(){
        this.container.toggleClass('active', false);
    }

}

export default Article;


// WEBPACK FOOTER //
// ./Article.js